let base = window._env_.VUE_APP_ADMIN_HOST

/**
 * 获取大屏项目列表
 * @param {Object} params - 查询参数
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页条数
 * @param {string} params.projectNumber - 项目编号
 * @param {string} params.executionTimeStart - 执行时间开始
 * @param {string} params.executionTimeEnd - 执行时间结束
 * @param {number} params.provinceId - 省份ID
 * @param {number} params.cityId - 城市ID
 * @returns {Promise} - 返回Promise对象
 */
export function getScreenProjectList (params) {
  return axios.post(`${base}/screen_project/query`, params)
}

/**
 * 批量修改大屏项目
 * @param {Object} data - 批量修改数据
 * @param {number[]} data.ids - 项目ID数组
 * @param {Object} data.data - 要修改的数据
 * @returns {Promise} - 返回Promise对象
 */
export function batchUpdateScreenProject (data) {
  return axios.post(`${base}/screen_project/batch_update`, data)
}

/**
 * 导出大屏项目列表
 * @param {Object} params - 查询参数
 * @returns {Promise} - 返回Promise对象
 */
export function exportScreenProjectList (params) {
  return axios.post(`${base}/screen_project/export`, params, {
    responseType: 'blob'
  })
}

/**
 * 获取大屏展示设置列表
 * @returns {Promise} - 返回Promise对象
 */
export function getDisplaySettings () {
  return axios.get(`${base}/data_screen/project/get_all`)
}

/**
 * 保存大屏展示设置
 * @param {Object} data - 展示设置数据
 * @param {Array} data.projects - 项目列表
 * @param {number} data.projects[].customerid - 客户ID
 * @param {number} data.projects[].projectid - 项目ID
 * @param {string} data.projects[].startdate - 开始日期
 * @param {string} data.projects[].enddate - 结束日期
 * @param {number} data.projects[].sort_priority - 排序优先级
 * @returns {Promise} - 返回Promise对象
 */
export function saveDisplaySettings (data) {
  return axios.post(`${base}/data_screen/project/save_all`, data)
}

/**
 * 获取大屏项目详情
 * @param {number} id - 项目ID
 * @returns {Promise} - 返回Promise对象
 */
export function getScreenProjectDetail (id) {
  return axios.get(`${base}/screen_project/get_${id}`)
}

/**
 * 创建大屏项目配置
 * @param {Object} data - 项目配置数据
 * @returns {Promise} - 返回Promise对象
 */
export function createScreenProject (data) {
  return axios.post(`${base}/screen_project/create`, data)
}

/**
 * 更新大屏项目配置
 * @param {number} id - 项目ID
 * @param {Object} data - 项目配置数据
 * @returns {Promise} - 返回Promise对象
 */
export function updateScreenProject (id, data) {
  return axios.post(`${base}/screen_project/update/${id}`, data)
}

/**
 * 获取项目城市列表
 * @param {Object} params - 查询参数
 * @param {number} params.projectId - 项目ID
 * @returns {Promise} - 返回Promise对象
 */
export function getProjectCityList (params) {
  return axios.post(`${base}/data_screen/project/project_city/query`, params)
}

/**
 * 获取项目城市详情
 * @param {number} id - 项目城市ID
 * @returns {Promise} - 返回Promise对象
 */
export function getProjectCityDetail (id) {
  return axios.get(`${base}/data_screen/project/project_city/get_${id}`)
}

/**
 * 更新项目城市配置
 * @param {number} id - 项目城市ID
 * @param {Object} data - 项目城市配置数据
 * @returns {Promise} - 返回Promise对象
 */
export function updateProjectCity (id, data) {
  return axios.post(`${base}/data_screen/project/project_city/update_${id}`, data)
}

/**
 * 获取审单大屏配置
 * @returns {Promise} - 返回Promise对象
 */
export function getAuditScreenConfig () {
  return axios.get(`${base}/data_screen/audit_screen_project/get_all`)
}

/**
 * 保存审单大屏配置
 * @param {Object} data - 审单大屏配置数据
 * @param {Array} data.projects - 项目列表
 * @param {number} data.projects[].customerid - 客户ID
 * @param {number} data.projects[].projectid - 项目ID
 * @param {string} data.projects[].startdate - 开始日期
 * @param {string} data.projects[].enddate - 结束日期
 * @param {number} data.projects[].sort_priority - 排序优先级
 * @param {number} data.projects[].target_quantity - 目标单量
 * @returns {Promise} - 返回Promise对象
 */
export function saveAuditScreenConfig (data) {
  return axios.post(`${base}/data_screen/audit_screen_project/save_all`, data)
}




// WEBPACK FOOTER //
// ./src/views/statistic/pages/ScreenProject/screen-project.api.js